import { filterText } from './getFilterContextMenu.locstring.json';
import loc from 'owa-localize';
import { onFilterMenuIsOpenChanged } from '../actions/publicActions';
import { assertNever } from '@uifabric/utilities';
import { ControlIcons } from 'owa-control-icons';
import { DisplayOption, FilterableMenuItem } from 'owa-filterable-menu';
import { isFeatureEnabled } from 'owa-feature-flags';

import {
    IContextualMenuItem,
    ContextualMenuItemType,
    IContextualMenuProps,
} from 'office-ui-fabric-react/lib/ContextualMenu';
import { FileExtensionType } from 'owa-files-filter-file-extensions-filter';
import {
    getFileExtensionContextMenuItems,
    IsFileExtensionSelectedFuncType,
    BoolSelectorFuncType,
    getExtensionContextMenuItem,
    getAllContextMenuItem,
    getLinksOnlyContextMenuItem,
} from './getFileExtensionContextMenuItems';
import {
    getDateRangeContextMenuItems,
    IsDateRangeOptionSelectedFuncType,
} from './getDateRangeContextMenuItems';

import {
    selectImageContextMenuItemAction,
    selectFileExtensionAction,
    selectAllFilesContextMenuItemAction,
} from '../actions/publicActions';

export enum FilesFilterContextMenuType {
    Files,
    Images,
    All,
    GroupView,
}

export function getFilterContextMenu(
    filesFilterContextMenuType: FilesFilterContextMenuType.Images,
    isDateRangeOptionSelectedCheck: IsDateRangeOptionSelectedFuncType
);
export function getFilterContextMenu(
    filesFilterContextMenuType: FilesFilterContextMenuType.Files,
    isDateRangeOptionSelectedCheck: IsDateRangeOptionSelectedFuncType,
    isExtensionSelected: IsFileExtensionSelectedFuncType,
    isExtensionFilterExpanded: BoolSelectorFuncType
);
export function getFilterContextMenu(
    filesFilterContextMenuType: FilesFilterContextMenuType.All,
    isDateRangeOptionSelectedCheck: IsDateRangeOptionSelectedFuncType,
    isExtensionSelected: IsFileExtensionSelectedFuncType,
    isExtensionFilterExpanded: BoolSelectorFuncType,
    isNoExtensionSelected?: BoolSelectorFuncType
);
export function getFilterContextMenu(
    filesFilterContextMenuType: FilesFilterContextMenuType.GroupView,
    isDateRangeOptionSelectedCheck: IsDateRangeOptionSelectedFuncType,
    isExtensionSelected: IsFileExtensionSelectedFuncType,
    isExtensionFilterExpanded: BoolSelectorFuncType
);
export function getFilterContextMenu(
    filesFilterContextMenuType: FilesFilterContextMenuType,
    isDateRangeOptionSelectedCheck: IsDateRangeOptionSelectedFuncType,
    isExtensionSelected?: IsFileExtensionSelectedFuncType,
    isExtensionFilterExpanded?: BoolSelectorFuncType,
    isNoExtensionSelected?: BoolSelectorFuncType,
    isLinksFilterSelected?: BoolSelectorFuncType
);
export function getFilterContextMenu(
    filesFilterContextMenuType: FilesFilterContextMenuType,
    isDateRangeOptionSelectedCheck: IsDateRangeOptionSelectedFuncType,
    isExtensionSelected?: IsFileExtensionSelectedFuncType,
    isExtensionFilterExpanded?: BoolSelectorFuncType,
    isNoExtensionSelected?: BoolSelectorFuncType,
    isLinksFilterSelected?: BoolSelectorFuncType
) {
    let items;
    switch (filesFilterContextMenuType) {
        case FilesFilterContextMenuType.Images:
            items = getDateRangeContextMenuItems(isDateRangeOptionSelectedCheck);
            break;
        case FilesFilterContextMenuType.Files:
            items = [
                ...getFileExtensionContextMenuItems(
                    isExtensionSelected,
                    isExtensionFilterExpanded,
                    false
                ),
                getDivider(1),
                ...getDateRangeContextMenuItems(isDateRangeOptionSelectedCheck),
            ];
            break;
        case FilesFilterContextMenuType.All:
            if (isFeatureEnabled('doc-fileshub-linksInBody')) {
                items = [
                    //All
                    getAllContextMenuItem(isNoExtensionSelected),
                    //Photos
                    getExtensionContextMenuItem(
                        FileExtensionType.Images,
                        isExtensionSelected,
                        selectImageContextMenuItemAction,
                        null, //use default clear filter action
                        true
                    ),

                    //Links
                    getLinksOnlyContextMenuItem(isLinksFilterSelected),
                    getDivider(1),
                    //All Files
                    getExtensionContextMenuItem(
                        FileExtensionType.Files,
                        isExtensionSelected,
                        selectAllFilesContextMenuItemAction,
                        null, //use default clear filter action
                        true
                    ),
                    //Files extensions
                    ...getFileExtensionContextMenuItems(
                        isExtensionSelected,
                        isExtensionFilterExpanded,
                        false,
                        selectFileExtensionAction
                    ),
                    getDivider(2),
                    //Date ranges
                    ...getDateRangeContextMenuItems(isDateRangeOptionSelectedCheck),
                ];
            } else {
                items = [
                    //All
                    getAllContextMenuItem(isNoExtensionSelected),
                    //Photos
                    getExtensionContextMenuItem(
                        FileExtensionType.Images,
                        isExtensionSelected,
                        selectImageContextMenuItemAction,
                        null, //use default clear filter action
                        true
                    ),
                    getDivider(1),
                    //All Files
                    getExtensionContextMenuItem(
                        FileExtensionType.Files,
                        isExtensionSelected,
                        selectAllFilesContextMenuItemAction,
                        null, //use default clear filter action
                        true
                    ),
                    //Files extensions
                    ...getFileExtensionContextMenuItems(
                        isExtensionSelected,
                        isExtensionFilterExpanded,
                        false,
                        selectFileExtensionAction
                    ),
                    getDivider(2),
                    //Date ranges
                    ...getDateRangeContextMenuItems(isDateRangeOptionSelectedCheck),
                ];
            }
            break;
        case FilesFilterContextMenuType.GroupView:
            items = [
                ...getFileExtensionContextMenuItems(
                    isExtensionSelected,
                    isExtensionFilterExpanded,
                    true
                ),
                getDivider(1),
                ...getDateRangeContextMenuItems(isDateRangeOptionSelectedCheck),
            ];
            break;
        default:
            assertNever(filesFilterContextMenuType);
    }

    const menu: IContextualMenuProps = {
        onMenuOpened: () => onFilterMenuIsOpenChanged(true),
        onMenuDismissed: () => onFilterMenuIsOpenChanged(false),
        items: items,
    };
    const menuItem = new FilterableMenuItem(
        loc(filterText) /* name */,
        ControlIcons.Filter /* icon */,
        () => {} /* onClick */,
        () => true /* shouldShow */,
        DisplayOption.Left /* displayOption */,
        false /* disabled */,
        menu
    );
    return menuItem;
}

function getDivider(index: number): IContextualMenuItem {
    return {
        key: 'extension_date_divider' + index,
        itemType: ContextualMenuItemType.Divider,
    };
}
